var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 0.333336H1.33333V2H14.6667V0.333336ZM15.5 8.66667V7L14.6667 2.83334H1.33333L0.5 7V8.66667H1.33333V13.6667H9.66667V8.66667H13V13.6667H14.6667V8.66667H15.5ZM8 12H3V8.66667H8V12Z",
    fill: "current",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacility);
export default __webpack_public_path__ + "static/media/facility.a93f94d310a29826efbb65f55157e6d2.svg";
export { ForwardRef as ReactComponent };